import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services*/
import { CachedDataService } from '@services/data/cached-data.service';
import { DevicesService } from '@services/http/devices.service';
import { StateService } from '@services/state.service';

/*Models*/
import { Device } from '@models/device';
import { DeviceState } from '@models/device-state';

import { CONFIG } from '../../config';
@Injectable()

export class CommandsService implements OnDestroy {
  currentDevice: Device;
  arrayCommands: Array<any> = [];
  getCommandsSubject: Subject<any> = new Subject<any>();
  getCommandsObservable = this.getCommandsSubject.asObservable();

  getCommandsGroupSubject: Subject<any> = new Subject<any>();
  getCommandsGroupObservable = this.getCommandsGroupSubject.asObservable();

  ifLoadCommand = false;

  ifLoadCommandSubject: Subject<any> = new Subject<any>();
  ifLoadCommandObservable = this.ifLoadCommandSubject.asObservable();


  commandsGroup: Array<any>;
  commands: Array<any>;
  state: DeviceState;
  ifLoadCommandEvent: EventEmitter<any> = new EventEmitter<any>();
  ngUnsubscribe: Subject<void> = new Subject<void>();
  commandIconList = CONFIG.commandIcon;

  constructor(
    private devicesService: DevicesService,
    private stateService: StateService,
    private cachedDataService: CachedDataService,
  ) {
    this.currentDevice = this.stateService.currentDevice;

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        /*clear command list if device change */
        this.commands = null;
        this.getGroups();
      });

    this.getCommandsGroupObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(groups => {
        groups = groups.filter(group => !group.isSms);
        this.commandsGroup = this.loadSelectedCommandsGroups(groups);
        this.filterCommands();
      });
    this.ifLoadCommandObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.ifLoadCommand = value;
      });

    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {
        this.state = state;
        this.filterCommands();
      });
  }



  getGroups() {
    if (this.currentDevice) {
      this.devicesService.getCommandGroups(this.currentDevice.id).subscribe(result => {
        result.map((command) => {
          command['checked'] = false;
        });
        this.getCommandsGroupSubject.next(result);
      });
    }
  }

  getCommand() {
    if (this.ifLoadCommand) {
      return false;
    }
    this.ifLoadCommandSubject.next(true);

    if (!this.commands) {
      this.devicesService.getCommand(this.currentDevice.id).subscribe(result => {
        this.commands = result.filter(command => command.id != null && command.group != null);
        this.filterCommands();
      });
    } else {
      this.filterCommands();
    }
  }

  loadSelectedCommandsGroups(newCommandsGroup) {
    const selectedGroupCommand = this.cachedDataService.getSelectedGroupCommand();
    if (selectedGroupCommand) {
      /*load selected group command */
      newCommandsGroup.map((command) => {
        selectedGroupCommand.map((selectCommand) => {
          if (command.key === selectCommand.key) {
            command.checked = selectCommand.checked;
          }
        });
      });
    }

    return newCommandsGroup;
  }

  filterCommands() {
    if (!this.commandsGroup || !this.commands) {
      return false;
    }

    this.arrayCommands = [];
    const selectCommandsGroup = [];

    this.commandsGroup.map((command) => {
      if (command.checked) {
        /*get only checked group */
        selectCommandsGroup.push(command);
      }
    });


    selectCommandsGroup.map(group => {
      const tempArray = this.commands.filter(command => command.group === group.key);
      if (tempArray.length) {
        tempArray.map((item) => {
          if (!item.condition) {
            /*if always show */
            item['show'] = true;
          } else {
            if (
              (!this.state.mainStates[item.group] && item.condition.indexOf('false') >= 0) ||
              (this.state.mainStates[item.group] && item.condition.indexOf('true') >= 0)
            ) {
              item['show'] = true;
            } else {
              item['show'] = false;
            }
          }
          let icon = this.commandIconList[item.templateId];
          if (!icon) {
            icon = this.commandIconList['default'];
          }
          item['icon'] = icon.iconName;

        });
        this.arrayCommands.push({ key: group.key, title: group.title, data: tempArray });
      }
    });
    this.getCommandsSubject.next(this.arrayCommands);
    this.ifLoadCommandSubject.next(false);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/commands.service.ts